import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  pageWrapper: {
    display: 'grid',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  heroCard: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
  },
  heroTop: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  heroActions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  heroActionButton: {
    whiteSpace: 'nowrap',
  },
  banner: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    borderLeft: `4px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.action.hover,
  },
  bannerWarning: {
    borderLeftColor: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
  },
  personalDataWarning: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    borderLeft: `4px solid ${theme.palette.warning.main}`,
    backgroundColor: theme.palette.warning.light,
  },
  personalDataWarningTitle: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  card: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
  },
  detailGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    alignItems: 'start',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  detailField: {
    display: 'grid',
    gap: theme.spacing(0.5),
  },
  detailLabel: {
    color: theme.palette.text.secondary,
  },
  detailValue: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  requestWorkPanel: {
    padding: theme.spacing(2.5, 3),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  requestWorkSections: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  sectionIntroText: {
    maxWidth: 960,
    color: theme.palette.text.secondary,
  },
  statusGuidance: {
    color: theme.palette.text.secondary,
  },
  requestTypes: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
  },
  requestTypeChip: {
    maxWidth: 180,
  },
  caseContextAccordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0, 3),
    '& .MuiAccordion-root': {
      boxShadow: 'none',
    },
  },
  sectionAccordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0, 3),
    '& .MuiAccordion-root': {
      boxShadow: 'none',
    },
  },
  accordionIntro: {
    marginBottom: theme.spacing(2),
  },
  dialogIntro: {
    marginBottom: theme.spacing(2),
  },
  accordionContent: {
    display: 'block',
    width: '100%',
  },
  requestTypeCard: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
  },
  requestTypeHeader: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  requestTypeMeta: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  formGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    alignItems: 'start',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formFullWidth: {
    gridColumn: '1 / -1',
  },
  booleanRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  statusLogPanel: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  statusLogList: {
    display: 'grid',
    gap: theme.spacing(1),
  },
  statusLogRow: {
    display: 'grid',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  statusLogMeta: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexWrap: 'wrap',
    color: theme.palette.text.secondary,
  },
  completionReadinessWarning: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    borderLeft: `4px solid ${theme.palette.warning.main}`,
    backgroundColor: theme.palette.warning.light,
  },
  completionReadinessOk: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  completionReadinessList: {
    margin: theme.spacing(1, 0, 0),
    paddingLeft: theme.spacing(3),
  },
  sectionActions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
  linkButton: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  resizableTextarea: {
    resize: 'vertical',
    minHeight: '48px',
  },
}));

export default useStyles;
